const prefix = '@coffeeandjoy/';
const storage = {
  set(key, value){
    if(typeof value === 'object'){
      value = JSON.stringify(value);
    }

    localStorage.setItem(`${prefix}${key}`, value);
  },

  get(key){
    let value = localStorage.getItem(`${prefix}${key}`);

    try{
      value = JSON.parse(value);
    }
    catch(e){}

    return value;
  }
}

export default storage;
